import { memo } from 'react';
import { Button, RoundedCard, Text } from '../../components';
import { content } from "./content";
import whoWeAre from '../../assets/images/who-we-are.png';
import bgImage2 from "../../assets/images/bg-image2.png";
import "./WhoWeAre.scss";

function MemoComponent({ id }: { id: string}) {
  return (
    <section id={id} className="who-we-are">
      <div className="section-content">
        <div className=" display-flex flex-wrap gap-30">
          <div className="left-side display-flex-column space-between gap-30">
            <div>
              <Text variant="title2" weight={700} className="section-title mb-30">
                {content.title}
              </Text>

              <Text variant="content2" color="tertiary" className="section-description mb-20">
                {content.paragraph1}
              </Text>
              <Text variant="content2" color="tertiary" className="section-description mb-30">
                {content.paragraph2}
              </Text>
            </div>

            <RoundedCard>
              <Text variant="subtitle2" weight={700} className="mb-30">
                Let's Schedule a Meeting
              </Text>

              <Button label="Schedule Meeting" size="md" onClick={() => {
              }}/>
            </RoundedCard>
          </div>

          <div className="right-side">
            <img src={whoWeAre} alt="professional"/>
          </div>
        </div>
      </div>

      <img src={bgImage2} alt="background decorators" className="bg-image"/>
    </section>
  )
};

export const WhoWeAre = memo(MemoComponent);